import {
  Container, 
  Form,
  ListGroup, 
  ListGroupItem,
  ListGroupItemHeading,
  Button,
  ButtonGroup 
} from 'reactstrap';
import './layout.css';
import AudioCapturePopup from "../helpers/AudioCapturePopup.js";

function CheckListContent(props){
  console.log("rendering CheckListContent, with props: ", props);
  const{
    steps,
    currentStep,
    trainingTitle
  } = props;
  if(!steps || steps.length === 0) return (<div>No checklist steps defined</div>);

  const match = steps.find(item => currentStep === item.Step);
  const selectedStep = match ? match.Index : -1;

  var stepsToShow = {};
  if(steps.length <= 5 || selectedStep < 0 || selectedStep >= steps.length){
    stepsToShow = steps;
  }else if(steps[selectedStep].Index < 3){
    stepsToShow = steps.slice(0, 5);
  }else if(steps[selectedStep].Index >= steps.length - 3){
    stepsToShow = steps.slice(-5);
  }else{
    stepsToShow = steps.slice(selectedStep - 2, selectedStep + 3)
  }

  return (
    <Container className="instruct-checklist-container" fluid={true}>
      <legend className="instruct-checklist-title">{trainingTitle}</legend>
      <ListGroup className="instruct-checklist-listgroup list-group-flush scrollable-listgroup" flush={true} variant="flush">
        {stepsToShow.map((item) => {
          return (
            <ListGroupItem
              className={item.Index === selectedStep ? "instruct-selected-checklist-item" : "instruct-checklist-item"}
              key={item.Index}
              active={item.Index === selectedStep}
            >
              <div>
                <ListGroupItemHeading style={{fontSize: '1.25em'}}>{item.Step}</ListGroupItemHeading>
                {item.Index === selectedStep && item.SubSteps &&
                  item.SubSteps.split('\n').map((subStep, index) => (
                    <div className="substep-string" key={index}>
                      {subStep}
                    </div>
                  ))}
              </div>
            </ListGroupItem>
          );
        })}
      </ListGroup>
    </Container>
  );
}

function CheckListPageControls(props){
  const{
    videoModelVisible,
    handleGoToVideoModel,
    NextStepText,
    videoModelText,
    handleNextClick,
    currentTraining,
    currentStep,
    updateState,
    audioButtonText
  } = props;
  console.log("CheckListPageControls with: ", props);
  return (
    <>
    <Form className='instruct-control-container'>
      <ButtonGroup className='instruct-control-bar' size='lg'>
          {/* <Button className='instruct-control-button' onClick={() => handleSetStartClick()}>{VideoStartText}</Button>
          <Button className='instruct-control-button' onClick={() => handleSetEndClick()}>{VideoEndText}</Button> */}
          <AudioCapturePopup 
            ref={window.audioRef} 
            buttonClass={'instruct-control-button'}
            currentTraining={currentTraining} 
            currentStep={currentStep} 
            updateState={updateState} 
            buttonText={audioButtonText}
          />
          {videoModelVisible && <Button className='instruct-control-button' onClick={() => handleGoToVideoModel()}>{videoModelText}</Button>}
          <Button className='instruct-control-button' color='primary' onClick={() => handleNextClick()}>{NextStepText}</Button>
      </ButtonGroup>
    </Form>
    </>
  );
}
export {CheckListContent, CheckListPageControls};